import "./custom-button.scss";

const CustomButton = ({ title, styles, handleClick, classes, ...props }) => {
  return (
    <button
      onClick={handleClick}
      className={`custom-button ${classes}` }
      style={{ ...styles }}
      type="button"
      {...props}
    >
      {title}
    </button>
  );
};

export default CustomButton;
